// extracted by mini-css-extract-plugin
export default {"iconContainer":"beachDistanceFeature-module__iconContainer__0j6Rk"};